import React from 'react';
import { createRoot } from 'react-dom/client';

import {
  AppRouter,
  WithAntdConfig,
  WithProviders,
  WithInitialData,
  WithLingui,
  WithQueryClient,
} from '@app';

import { AppErrorBoundary } from './components/common/AppErrorBoundary/AppErrorBoundary';
import { FeatureFlagsProvider } from './featureFlags/FeatureFlagsProvider';

import '@styles/styles.scss';
import 'antd/dist/reset.css';
import 'moment/dist/locale/cs';
import '@xyflow/react/dist/style.css';

import './sentry';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <WithQueryClient>
      <FeatureFlagsProvider>
        <WithProviders>
          <WithLingui>
            <WithAntdConfig>
              <AppErrorBoundary>
                <WithInitialData>
                  <AppRouter />
                </WithInitialData>
              </AppErrorBoundary>
            </WithAntdConfig>
          </WithLingui>
        </WithProviders>
      </FeatureFlagsProvider>
    </WithQueryClient>
  </React.StrictMode>,
);
